import { render, staticRenderFns } from "./recipients-tracker.vue?vue&type=template&id=42d98a2f&scoped=true&"
import script from "./recipients-tracker.vue?vue&type=script&lang=js&"
export * from "./recipients-tracker.vue?vue&type=script&lang=js&"
import style0 from "./recipients-tracker.vue?vue&type=style&index=0&id=42d98a2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d98a2f",
  null
  
)

export default component.exports